import React from 'react';
import PropTypes from 'prop-types';

import { RadioButtonContent, RadioButtonIndicator, RadioButtonWrapper } from './RadioButton.style';
import { childrenType } from '../../../IbePropTypes';

const propTypes = {
  children: childrenType,
  isErrored: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  error: PropTypes.bool,
};

const defaultProps = {
  children: <></>,
  isErrored: false,
  isHighlighted: false,
  isSelected: false,
  error: false,
  onClick: () => { },
};

const RadioButton = ({
  children,
  isErrored,
  isSelected,
  isHighlighted,
  onClick,
  error,
}) => (
  <RadioButtonWrapper
    onClick={onClick}
    isSelected={isSelected}
    isErrored={isErrored}
    isHighlighted={isHighlighted}
    data-error={error}
  >
    <RadioButtonIndicator isSelected={isSelected} />
    <RadioButtonContent>{children}</RadioButtonContent>
  </RadioButtonWrapper>
);

RadioButton.propTypes = propTypes;

RadioButton.defaultProps = defaultProps;

export default RadioButton;
